'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactUtils = require('react-utils');

exports.default = (0, _reactUtils.keyMirror)({
  // form state
  SET_FORM_FIELD: null,

  SET_FORM_STATE: null,
  RESET_FORM_STATE: null,

  SET_CONSENT_RESPONSES: null,
  RESET_CONSENT_RESPONSES: null,

  LOG_ERROR_PAGE_SHOWN: null,

  SHOW_USER_MESSAGE: null,

  SET_TIMEZONE: null,
  SET_EVENT_DATE: null,
  SET_EVENT_DATE_TIME: null,
  SET_EVENT_DURATION: null,
  SET_GIVEN_CONSENT: null,

  // Book actions
  LOG_MEETING_CREATE: null,
  BOOKING_TIME_CONFLICT: null,

  COMPANY_NAME_FETCH_STARTED: null,
  COMPANY_NAME_FETCH_SUCCEEDED: null,
  COMPANY_NAME_FETCH_FAILED: null,

  USER_PROFILE_FETCH_STARTED: null,
  USER_PROFILE_FETCH_SUCCEEDED: null,
  USER_PROFILE_FETCH_FAILED: null,

  SET_ACTIVE_LOCALE: null,
  SET_ACTIVE_LOCALE_FINISHED: null,

  PUBLIC_AVAILABILITY_INFO_FETCH_STARTED: null,
  PUBLIC_AVAILABILITY_INFO_FETCH_SUCCEEDED: null,
  PUBLIC_AVAILABILITY_INFO_FETCH_FAILED: null,

  PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_STARTED: null,
  PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_SUCCEEDED: null,
  PUBLIC_AVAILABILITY_INFO_OWNER_FETCH_FAILED: null,

  MEETING_CREATE_STARTED: null,
  MEETING_CREATE_SUCCEEDED: null,
  MEETING_CREATE_FAILED: null,
  MEETING_CREATE_UNINITIALIZED: null,

  // Public global branding actions
  PUBLIC_GLOBAL_BRANDING_FETCH_STARTED: null,
  PUBLIC_GLOBAL_BRANDING_FETCH_SUCCEEDED: null,
  PUBLIC_GLOBAL_BRANDING_FETCH_FAILED: null,

  TOGGLE_TROUBLESHOOT_MODE: null
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/workspace/MeetingsUI/MeetingsLib/target/src/MeetingsLib/static-2.875/js/redux/actions/ActionTypes.js
// module id = 7
// module chunks = 0